import { createSelector } from '@ngrx/store';
import * as fromFeature from './../reducers';
import * as fromLogin from '../reducers/login.reducer';


export const selectSessionFeature = createSelector(fromFeature.featureSelector, (auth: fromLogin.State) => auth);

export const selectSessionAuthenticate = createSelector(selectSessionFeature, auth => auth.isAuthentiate);

export const selectSessionIsloaded = createSelector(selectSessionFeature, auth => auth.loaded);

export const selectSessionIsloading = createSelector(selectSessionFeature, auth => auth.loading);

export const selectSessionToken = createSelector(selectSessionFeature, auth => auth.accesToken);

export const selectSessionCurrentrole = createSelector(selectSessionFeature, auth => auth.currentRole);

export const selectSessionUser = createSelector(selectSessionFeature, auth => auth.user);

export const selectSessionUserRoles = createSelector(selectSessionUser, user => user ? user.roles : null);

export const selectUserLoading = createSelector(selectSessionFeature, auth => auth.userLoading);

export const selectUserLoaded = createSelector(selectSessionFeature, auth => auth.userLoaded );
